export function deleteAllCookies() {
  let cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    let eqPos = cookie.indexOf('=');
    let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
}

export function getSortName(param: string): string {
  const name = param && param.split(' ');
  const sortName = name && name[0].charAt(0) + name[1].charAt(0);
  return sortName;
}

export function getDisplayName(param: string): string {
  return param && param.split(' ')[0];
}

export function stringToDate(str: any) {
  const [dd, mm, yyyy] = str.split('-');
  return new Date(yyyy, mm - 1, dd);
}

// Matches Bootstrap's "md" breakpoint (768px), which is also where this app's filter-box
// fields switch from stacked (col-12) to side-by-side (col-md-6+) layout. Used to decide
// whether a page's filter box should start collapsed (small/mobile screens, opened via the
// Filters button) or expanded (tablet/desktop, as it always has been).
const MOBILE_BREAKPOINT_PX = 768;

export function isMobileViewport(): boolean {
  return typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT_PX;
}

// Saves a Blob to the user's machine under the given file name (replaces the file-saver package:
// every browser this app supports honours <a download> on a blob URL). The URL is revoked after a
// short delay, not straight after click() - revoking synchronously can cancel the download.
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
